import { useState, useEffect } from 'react';
import request from 'superagent';

export function useDataFetch(uri) {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState();

  useEffect(() => {
    setLoading(true);

    request
      .get(uri)
      .then(res => {
        setItems(res.body);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, [uri]);

  return { loading, items };
}
